/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EscrowStatus
 */
export interface EscrowStatus {
    /**
     * 
     * @type {string}
     * @memberof EscrowStatus
     */
    self: string;
    /**
     * 
     * @type {string}
     * @memberof EscrowStatus
     */
    other: string;
    /**
     * 
     * @type {string}
     * @memberof EscrowStatus
     */
    total: string;
}

export function EscrowStatusFromJSON(json: any): EscrowStatus {
    return EscrowStatusFromJSONTyped(json, false);
}

export function EscrowStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EscrowStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'self': json['self'],
        'other': json['other'],
        'total': json['total'],
    };
}

export function EscrowStatusToJSON(value?: EscrowStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'self': value.self,
        'other': value.other,
        'total': value.total,
    };
}


